// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BPOok","colMin":"styles_colMin__2Z1Xp"};